// extracted by mini-css-extract-plugin
export default {"marker":"Picture_marker__+7voO","content":"Picture_content__BSmbv","dragging":"Picture_dragging__I4tlC","container":"Picture_container__d6YFi","rotate":"Picture_rotate__Ogpz5"};